import { extendZodWithOpenApi } from "@asteasolutions/zod-to-openapi";
import { z } from "zod";
import { rrulestr } from "../utils/RRuleLibrary.js";

extendZodWithOpenApi(z);

/**
 * Zod schema for recurrence rule strings accepted by the shared RRule parser.
 */
export const RRuleString = z
    .string()
    .refine(
        (value) => {
            try {
                rrulestr(value);
                return true;
            } catch {
                return false;
            }
        },
        {
            message: "Invalid rrule string",
        },
    )
    .openapi({
        type: "string",
        description: "Recurrence rule string in rrule format",
        example: "DTSTART:20210609T000506Z\nRRULE:FREQ=WEEKLY;BYDAY=MO,TU,WE,TH,FR,SA,SU;INTERVAL=1",
    });
